//Reducer Types
interface State {
  sageConnectionData: any;
}

export const sageReducer = (
  state: State = {
    sageConnectionData: null,
  },
  action: any,
): State => {
  switch (action.type) {
    case "SAGE_CONNECTION_STATUS":
      return {
        ...state,
        sageConnectionData: action.payload,
      };
    case "DISCONNECT_SAGE":
      return {
        ...state,
        sageConnectionData: null,
      };
    default:
      return state;
  }
};
